import React, { useState } from 'react';
import RegisterForm from '../../components/Member/Register/registerForm';
import RegisterSuccess from '../../components/Member/Register/registerSuccess';

function Register() {
  const [registeredData, setRegisteredData] = useState(null);
  
  return (
    <div className="register-page-wrapper">
      {registeredData ? (
        <RegisterSuccess data={registeredData} />
      ) : (
        <RegisterForm onSuccess={setRegisteredData} />
      )}
    </div>
  );
}

export default Register;